import { ReactNode } from "react";
import "./InfiniteScroll.scss";
import { useInfiniteScroll } from "./hooks/useInfiniteScroll";

type IProps = {
  fetchMore: () => void | Promise<void>;
  hasMore: boolean;
  root?: string;
  children: ReactNode;
};

export const InfiniteScroll = ({ fetchMore, hasMore, root, children }: IProps) => {
  const spyElement = useInfiniteScroll({ fetchMore, hasMore, root });

  return (
    <>
      {children}
      <div className="infiniteScroll" ref={spyElement} key="spyElement"></div>
    </>
  );
};
